import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, inject, OnInit } from '@angular/core';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit {
  title = 'Amarant.Web';
  smallScreen = false;

  private authService = inject(AuthService);
  private breakpointObserver = inject(BreakpointObserver);

  currentUser$ = this.authService.currentUser;

  ngOnInit(): void {
    this.breakpointObserver.observe(['(max-width: 768px)']).subscribe(result => {
      if (result.matches) {
        this.smallScreen = true;
      } else {
        this.smallScreen = false;
      }
    });
  }
}
